export default function (blob) {
    return new Promise((resolve, reject) => {
        const img = new Image();

        img.onload = function () {
            // Use the "naturalWidth" property to get the width of the first frame.
            // For a single-frame image, naturalWidth will be the actual width.
            const width = img.naturalWidth;

            // Create a canvas element to extract the frames
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            canvas.width = width;
            canvas.height = img.naturalHeight;

            // Draw the first frame onto the canvas
            context.drawImage(img, 0, 0, width, img.naturalHeight);

            // Get the image data of the first frame
            const imageData = context.getImageData(0, 0, width, img.naturalHeight).data;

            // Check if there are more than one unique colors in the first frame
            const uniqueColors = new Set();
            for (let i = 0; i < imageData.length; i += 4) {
                const color = `${imageData[i]},${imageData[i + 1]},${imageData[i + 2]}`;
                uniqueColors.add(color);
            }

            // If there are more than one unique colors, it's likely an animated GIF
            const isAnimated = uniqueColors.size > 1;

            resolve(isAnimated);
        };

        img.onerror = function () {
            reject("Error loading image");
        };

        // Load the blob into the image
        img.src = URL.createObjectURL(blob);
    });
}